import { useState, useEffect } from "react";
import { SearchResponse } from "../../../types/SearchBar";
import { searchService } from "../Navbar/SearchService";
import { usePricingSessionRevision } from "../../../contexts/PricingSessionContext";

export function useDebouncedSearch() {
    const pricingSessionRevision = usePricingSessionRevision();
    const [searchTerm, setSearchTerm] = useState("");
    const [suggestions, setSuggestions] = useState<SearchResponse>({
        suggestions: [],
        totalResults: 0,
        searchTerm: "",
    });
    const [loading, setLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        let cancelled = false;

        if (!searchTerm.trim()) {
            setSuggestions({ suggestions: [], totalResults: 0, searchTerm: "" });
            setIsOpen(false);
            return;
        }

        const delayDebounceFn = setTimeout(async () => {
            setLoading(true);
            try {
                const results = await searchService.getSuggestions(searchTerm);
                if (cancelled) return;
                setSuggestions(results);
                setIsOpen(true);
            } catch (error) {
                if (cancelled) return;
                console.error("Search error:", error);
                setSuggestions({ suggestions: [], totalResults: 0, searchTerm });
            } finally {
                if (!cancelled) setLoading(false);
            }
        }, 300);

        return () => {
            cancelled = true;
            clearTimeout(delayDebounceFn);
        };
    }, [searchTerm, pricingSessionRevision]);

    const clearSearch = () => {
        setSearchTerm("");
        setSuggestions({ suggestions: [], totalResults: 0, searchTerm: "" });
        setIsOpen(false);
    };

    return {
        searchTerm,
        setSearchTerm,
        suggestions,
        loading,
        isOpen,
        setIsOpen,
        clearSearch,
    };
}
